import axios from 'axios';
import { offerCreditTopUp } from '../creditTopUp';
import { isEmbroideryTrace } from '../../config/appVariant';

export async function requestModify(images, modificationRequest, user, signal) {
  if (!user) throw new Error('Please sign in to modify an image.');
  const normalized = (Array.isArray(images) ? images : [images]).map(image => image.split(',')[1] || image);
  const body = normalized.length === 1 ? {base64Image: normalized[0], modificationRequest}
    : {base64Images: normalized, modificationRequest};
  if (isEmbroideryTrace) body.requestId = crypto.randomUUID();
  const endpoint = isEmbroideryTrace ? 'embroideryModify' : 'modifyImageNanoBanana';
  try {
    return await axios.post(`https://us-central1-svgtrace-pro.cloudfunctions.net/${endpoint}`, body, {
    headers: {Authorization: `Bearer ${await user.getIdToken()}`, 'Content-Type': 'application/json'},
    timeout: isEmbroideryTrace ? 540000 : 180000, signal,
    });
  } catch (error) {
    offerCreditTopUp(error, 'Modify');
    throw error;
  }
}
